import { useNavigation, useRoute } from '@react-navigation/core'
import { useEffect, useState } from 'react'
import { AmountInput } from '../../comps/AmountInput'
import { TransactionQueryComp } from '../../comps/TransactionQueryComp'
import { Screens } from '../../nav/Screens'

export const FundTransferScreen = () => {
  const navigation = useNavigation()
  const routes: any = useRoute()
  const [amount, setAmount] = useState(routes?.params?.amount ?? null)

  const isDisabled = () => (!amount || amount < 10 ? true : false)

  useEffect(() => {
    navigation.setOptions({ headerTitle: 'Fund Transfer' })
  }, [navigation])

  return (
    <>
      <AmountInput
        amount={amount}
        onAmountChange={(text: any) => setAmount(text)}
        title={'Amount to be Transfered'}
        precision={2}
        transactionType="fund_transfer"
      />
      <TransactionQueryComp
        onSubmit={(data: any) =>
          navigation.navigate(
            Screens.REVIEW_FUND_TRANSFER as never,
            { amount: +amount + '', ...data, activityType: 'CUSTOMER_FT' } as never,
          )
        }
        params={{ ...(routes?.params ?? {}) }}
        isLoading={false}
        buttonText="Proceed"
        isDisabled={isDisabled()}
        screenName={Screens.FUND_TRANSFER}
        showFingerPrintModel={false}
        activityType="CUSTOMER_FT"
      />
    </>
  )
}
